import { FieldValues, UseFormReturn } from 'react-hook-form';
import { FormContainer, TextFieldElement } from 'react-hook-form-mui';
import * as Yup from 'yup';
import {
    Button,
    Card,
    CardActions,
    CardContent,
    CardHeader,
} from '@mui/material';

import { BusinessSignupNote } from '@barboxx/models';

// const columns: GridColDef[] = [
//     { field: 'content', headerName: 'Content', flex: 1 },
//     {
//         field: 'user',
//         headerName: 'Created By',
//         width: 170,
//         valueFormatter: param => {
//             const { displayName } = param?.value as User;
//             return displayName;
//         },
//     },
//     {
//         field: 'updatedAt',
//         headerName: 'Updated At',
//         width: 200,
//         type: 'date',
//         valueFormatter: params =>
//             moment(params.value as Date).format('MM/DD/YYYY-hh:mm:ssa'),
//     },
// ];

export const NOTES_SCHEMA: Yup.ObjectSchema<BusinessSignupNote.CreateRequest> =
    Yup.object({
        content: Yup.string().required('Required'),
        createdBy: Yup.number().required(),
        entityId: Yup.number().required(),
    });

// export interface FormValues extends Pick<BusinessSignupNote, 'content'> {
//     notes: BusinessSignupNote[];
// }

interface NotesFormProps<T extends FieldValues> {
    formContext: UseFormReturn<T>;
    onSubmit: (values: T) => void;
}

// const INITIAL_VALUES: FormValues = {
//     content: '',
//     notes: [],
// };

// const NoteRow = ({ content, updatedAt, createdBy }: BusinessSignupNote) => (
//     <div>
//         {content} - created by: {createdBy}
//         At: {updatedAt}
//     </div>
// );

export function NotesForm<
    T extends FieldValues = BusinessSignupNote.CreateRequest,
>({ formContext, onSubmit }: NotesFormProps<T>) {
    return (
        <FormContainer onSuccess={onSubmit} formContext={formContext}>
            <Card>
                <CardHeader title="Add Note" />
                <CardContent
                    sx={{
                        paddingY: 0,
                    }}
                >
                    <TextFieldElement
                        label="New Note"
                        name="content"
                        fullWidth
                        multiline
                        rows={3}
                    />
                </CardContent>
                <CardActions
                    sx={{
                        justifyContent: 'flex-end',
                    }}
                >
                    <Button
                        color="inherit"
                        onClick={() => {
                            formContext.reset();
                        }}
                    >
                        Cancel
                    </Button>

                    <Button
                        sx={{ alignSelf: 'flex-end' }}
                        type="submit"
                        variant="contained"
                        disabled={formContext.formState.isSubmitting}
                    >
                        Add
                    </Button>
                </CardActions>
            </Card>
        </FormContainer>
    );
}
